import axios from 'axios'
// import isEmpty from 'lodash/isEmpty'
import { route as routeGenerator } from './route'

//////////////////////////////////////////////////
////////////////////////////
/////////
// eslint-disable-next-line
import { store } from '@/main'
//////////

// Axios Common Error Handler
const errorResponseHandler = (error) => {
  // check for errorHandle config
  if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
    return Promise.reject(error)
  }

  // if has no response show network not working
  if (!error.response) {
    store.dispatch('message/showMessage', {
      type: 'danger',
      message: error.message,
      duration: 10000
    })
  } else {
    return Promise.reject(error)
  }
}

// apply interceptor on response
axios.interceptors.response.use(
  response => response,
  errorResponseHandler
)

const request = ({
  route,
  method = 'get',
  params = {},
  data = {},
  headers = {}
}) => {
  let url = routeGenerator(route, params)

  const requestHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/vnd.api.v2+json',
    ...headers
  }

  // Add Token to Request Header if present in Vuex Store
  const token = store.state.settings.token
  if (token && token.access_token) {
    requestHeaders['Authorization'] = `Bearer ${token.access_token}`
  }

  // console.log(data)
  // return new Promise((resolve, reject) => {
  //   let requestParams = {
  //     method,
  //     headers: requestHeaders
  //   }

  //   if (!isEmpty(data)) {
  //     requestParams['body'] = JSON.stringify(data)
  //   }

  //   fetch(url, requestParams)
  //     .then(res => res.json())
  //     .then(json => {
  //       resolve({
  //         data: json
  //       })
  //     })
  //     .catch(e => {
  //       console.error(e.stack)
  //       reject(e)
  //     })
  // })

  return axios({
    method,
    url,
    data,
    headers: requestHeaders
  })
}

export default request
